class OrigemService extends AbstractService

  configure: (configs, injector) ->
    configs.url = '/eficiencia-fiscal/origem-icms'

angular.module('eficienciaFiscalModule').service('origemService', OrigemService)
